import React from 'react';
import styled from 'styled-components';
import { Flex } from '@rebass/grid';
import { getTokenValue, THEME_TOKENS } from '@amtrav/theme-system';

const AgreePrivacyText = styled(Flex)`
  flex-wrap: wrap;
  font-size: 14px;
  line-height: 1.4;
`;

const AgreePrivacyLink = styled.a`
  text-decoration: none;
  color: ${getTokenValue(THEME_TOKENS.base.color.action)};
  margin: 0 4px;
`;

// eslint-disable-next-line react/prop-types
const UserAgreementLinks = ({ ml = 0, mb = '30px' }) => {
  return (
    <AgreePrivacyText ml={ml} mb={mb}>
      By signing up you agree to our
      <AgreePrivacyLink href="https://www.amtrav.com/user-agreement" target="_blank">
        User Agreement
      </AgreePrivacyLink>
      and
      <AgreePrivacyLink href="https://www.amtrav.com/privacy" target="_blank">
        Privacy Policy.
      </AgreePrivacyLink>
    </AgreePrivacyText>
  );
};

export default UserAgreementLinks;
